import { } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof OrganizationReleaseNoteAnimationSetupService.props>

export default class OrganizationReleaseNoteAnimationSetupService extends BaseSetupService<Props> {
	static readonly props = {
		step: {
			type: Number,
			default: 1,
		},
	};


	constructor (props?: Props) {
		super(props);
	}


	toggleActive (e: MouseEvent) {
		(e.target as Undef<HTMLElement>)?.classList.toggle('toggle--active');
	}
}
